/**
 * Stable CSS class names for E2E — Digital gift card management page & drawer.
 */
export const DCA = {
    pageHeader: 'digital-card-page__header',
    pageTitle: 'digital-card-page__title',
    inputButtonAdd: 'digital-card-input--button-add',
    tablePaper: 'digital-card-page__table-paper',
} as const;

export const DCAU = {
    drawerRoot: 'digital-card-add-edit-drawer',
    drawerBody: 'digital-card-add-edit-drawer__body',
    sectionPicture: 'digital-card-add-edit-drawer__section-picture',
    pictureToolbar: 'digital-card-add-edit-drawer__picture-toolbar',
    picturePreviewRow: 'digital-card-add-edit-drawer__picture-preview-row',
    dropzoneWrap: 'digital-card-add-edit-drawer__dropzone-wrap',
    inputTextfieldName: 'digital-card-add-edit-drawer-input--textfield-name',
    inputTextfieldDescription: 'digital-card-add-edit-drawer-input--textfield-description',
    rowTemplateStatus: 'digital-card-add-edit-drawer__row-template-status',
    inputSwitchTemplateStatus: 'digital-card-add-edit-drawer-input--switch-template-status',
    metadataSection: 'digital-card-add-edit-drawer__metadata-section',
    footer: 'digital-card-add-edit-drawer__footer',
    inputButtonSave: 'digital-card-add-edit-drawer-input--button-save',
} as const;

export const DCDG = {
    root: 'digital-card-drag-grid',
    loadingLinear: 'digital-card-drag-grid__loading-linear',
    tableWrap: 'digital-card-drag-grid__table-wrap',
    inputIconRowMenu: 'digital-card-drag-grid-input--icon-button-row-menu',
    linkOpenImage: 'digital-card-drag-grid-input--link-open-image',
} as const;

export const dcaCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const dcauCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const dcdgCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
